'use client';

import Button from '@ui/Button';
import Tooltip from '@ui/Tooltip';
import React from 'react';
import { cx } from 'cva';
import { HiHeart } from 'react-icons/hi';
import useUserProfile from '@/hooks/useUserProfile';
import useHasUserSession from '@/hooks/useHasUserSession';
import { getUserCountry } from '@/utils/user.helper';
import {
  fetchUserLocation,
  recordDonationClick,
} from '@/actions/public/server.actions';
import { useBreakpointHooks } from '@/utils/break-points.provider';
import useStripeContributionDialogStore from '../store/stripeContributionDialogSlice';
import {
  isContributeDisabled,
  isContributionPending,
} from '@/utils/donate.helper';

function ContributeButton(props) {
  const {
    variant = 'filled',
    amount = '',
    withIcon = false,
    fundraisingOrg,
    post,
    recordPayload,
    overrideCss,
    ...rest
  } = props;

  const isLoggedIn = useHasUserSession();
  const disabled = isContributeDisabled(fundraisingOrg, post);
  const pendingContributionStatus = isContributionPending(post);
  const setShowStripeContributionDialog = useStripeContributionDialogStore(
    (state) => state.setOpen,
  );

  const handleContribute = async () => {
    if (!disabled) {
      setShowStripeContributionDialog(true, {
        fundraisingOrg,
        amount,
        post,
      });

      if (recordPayload) {
        if (!isLoggedIn) {
          const userLocation = await fetchUserLocation();
          if (userLocation) {
            recordPayload.donationClick.location = userLocation;
          }
        }
        recordDonationClick(recordPayload);
      }
    }
  };

  const getDisabledTooltipText = () => {
    if (pendingContributionStatus) {
      return 'Pending';
    }
    return 'Contributions coming soon';
  };

  if (disabled) {
    // return (
    //   <Tooltip
    //     content={getDisabledTooltipText()}
    //     className={`min-w-[200px] max-w-[220px]`}>
    //     <Button
    //       variant={variant}
    //       color="primary"
    //       disabled
    //       role="button"
    //       as="div">
    //       <div
    //         className={cx(
    //           'flex items-center gap-1',
    //           isLesserThanMediumScreen && !overrideCss && 'text-[10px]',
    //         )}>
    //         Contribute
    //         {withIcon && <HiHeart />}
    //       </div>
    //     </Button>
    //   </Tooltip>
    // );
    return (
      <Tooltip
        content={getDisabledTooltipText()}
        className={`min-w-[200px] max-w-[220px]`}>
        <Button
          variant={variant}
          color="primary"
          disabled
          role="button"
          as="div"
          {...rest}>
          Contribute
        </Button>
      </Tooltip>
    );
  }

  return (
    <Button
      variant={variant}
      color="primary"
      onClick={handleContribute}
      {...rest}>
      Contribute
    </Button>
  );
}

export default ContributeButton;
